import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Webinar: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 540h-540v-390h465c41.35 0 75 33.64 75 75zm-510-30h480v-285c0-24.81-20.19-45-45-45h-435z' />
    <path d='m510 630h-240v-30h210c16.57 0 30 13.43 30 30z' />
    <path d='m390 410c-49.63 0-90-40.37-90-90s40.37-90 90-90 90 40.37 90 90-40.37 90-90 90zm0-150c-33.08 0-60 26.92-60 60s26.92 60 60 60 60-26.92 60-60-26.92-60-60-60z' />
    <path d='m510 470h-30c0-15.06-8.69-29.55-24.47-40.83-17.31-12.36-40.58-19.17-65.53-19.17s-48.22 6.81-65.53 19.17c-15.78 11.27-24.47 25.77-24.47 40.83h-30c0-25.01 13.15-48.18 37.04-65.24 22.35-15.97 51.82-24.76 82.96-24.76s60.61 8.79 82.96 24.76c23.88 17.06 37.04 40.23 37.04 65.24z' />
  </IconBase>
));

Webinar.displayName = 'Webinar';

export default Webinar;
